module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleInteractionFiltersChange
    },
    model: {
      value: (_vm.selectedChannelFilterList),
      callback: function($$v) {
        _vm.selectedChannelFilterList = $$v
      },
      expression: "selectedChannelFilterList"
    }
  }, _vm._l((_vm.getChannelsList()), function(channel, i) {
    return _c('el-checkbox', {
      key: i,
      attrs: {
        "label": _vm.getChannelName(channel)
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-413ad750","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/interaction/InteractionsFilter.vue
// module id = 3248
// module chunks = 3